import React, { useState } from 'react';
import {
  Modal,
  Col,
  Button,
  Form,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import { validateCredentialsForDO } from '../../Service/APIService';

const AuthModal = ({ onDismissClick, onSubmitSuccess }) => {
  const [fields, setFields] = useState({ userName: '', password: '' });
  const [errors, setErrors] = useState('');

  const isValid = () => {
    const { userName, password } = fields;
    let formIsValid = true;
    if (userName.trim() && password.trim()) {
      setErrors('');
    }
    if (!userName) {
      formIsValid = false;
      setErrors('Please enter username');
    } else if (!password) {
      formIsValid = false;
      setErrors('Please enter password');
    }
    return formIsValid;
  };

  const onSubmitClick = () => {
    if (isValid()) {
      // api call
      validateCredentialsForDO(fields.userName, fields.password)
        .then((res) => {
          if (res.data.statusCode === 200) {
            onSubmitSuccess();
          } else {
            setErrors('Invalid Credential...');
          }
        })
        .catch((err) => {
          setErrors(err?.response?.data?.message);
        });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields({ ...fields, [name]: value });
  };

  return (
    <Modal show={true} onHide={onDismissClick}>
      <Modal.Header closeButton>
        <Modal.Title>Enter Credentials</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ display: 'flow-root' }}>
        <Form>
          <FormGroup>
            <Col md={12}>
              <Col md={4} xs={12}>
                <label htmlFor="inputUsername">Username</label>
              </Col>
              <Col xs={12} md={8}>
                <FormControl
                  type="text"
                  id="inputUsername"
                  aria-describedby="username"
                  name="userName"
                  onChange={handleChange}
                />
              </Col>
            </Col>
          </FormGroup>
          <br />
          <FormGroup>
            <Col md={12}>
              <Col md={4} xs={12}>
                <label htmlFor="inputPassword">Password</label>
              </Col>
              <Col xs={12} md={8}>
                <FormControl
                  type="password"
                  id="inputPassword"
                  aria-describedby="password"
                  name="password"
                  onChange={handleChange}
                />
              </Col>
            </Col>
          </FormGroup>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <p className="invalid pull-left">&nbsp;{errors}</p>
        <Button onClick={onSubmitClick} bsStyle="success" bsSize="small">
          Submit
        </Button>

        <Button onClick={onDismissClick} bsStyle="danger" bsSize="small">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default AuthModal;
